import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EncryptService } from './encrypt.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient,
    private encryptService: EncryptService
  ) { }

  // Author: Leire Herranz.
  // Date: 18.01.2024.
  // Description: Obtain the token from cognito.
  obtainToken(body: any): Observable<any> {
    const API_URL = `${environment.keycloakUrl}/realms/${environment.keycloakRealm}`;

    const tokenUrl = `${API_URL}/protocol/openid-connect/token`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post(tokenUrl, body, { headers: headers });
  }
}